var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.515,
    height: 49,
    viewBox: "0 0 51.515 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path52032",
    d: "M213.564,413.955h-5.026v8.8h5.026Z",
    transform: "translate(-164.562 -373.75)",
    fill: "#ff7d73",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path53969",
    d: "M205.564,408.955h-5.026v15.077h5.026Z",
    transform: "translate(-166.614 -375.032)",
    fill: "#ffa95d",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path53975",
    d: "M197.564,404.066h-5.026v21.22h5.026v-21.22Z",
    transform: "translate(-168.665 -376.286)",
    fill: "#87d97a",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path53981",
    d: "M189.564,400.955h-5.026v25.129h5.026Z",
    transform: "translate(-170.717 -377.084)",
    fill: "#e7e7e7",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path53987",
    d: "M181.564,394.955h-5.026v32.667h5.026Z",
    transform: "translate(-172.768 -378.622)",
    fill: "#e7e7e7",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path24983",
    d: "M174.694,381.96a1.256,1.256,0,0,0-.714,2.209l25.129,21.359a1.257,1.257,0,0,0,1.86-.26l4.206-6.309,15.4,14.378c-.65,0-1.3,0-1.84,0a12.613,12.613,0,0,0-1.372.037,1.258,1.258,0,1,0,.294,2.5c-.106.013.484-.019,1.092-.022s1.372,0,2.118,0c1.491.009,2.91.027,2.91.027a1.257,1.257,0,0,0,1.271-1.256V408.34a1.256,1.256,0,1,0-2.513,0v3.391l-16.734-15.617a1.257,1.257,0,0,0-1.9.221l-4.243,6.363-24.051-20.444a1.257,1.257,0,0,0-.915-.294Z",
    transform: "translate(-173.538 -381.956)",
    fill: "#fb695e",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer12);
export default __webpack_public_path__ + "static/media/layer1 (2).4741c8b8664d086179f24d7e612031ca.svg";
export { ForwardRef as ReactComponent };